export default __webpack_public_path__ + "static/media/redeLogin.0f201c08.svg";